import { PackagePlus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import type { PreviewProduct } from '../lib/types';

type PapAddTarget = Pick<PreviewProduct, 'id' | 'title'> & { shopifyStatus?: PreviewProduct['shopifyStatus'] };

export function PapAddToErpDialog({
  open,
  onOpenChange,
  products,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  products: PapAddTarget[];
  onConfirm: () => void;
}) {
  const { t } = useTranslation('productSync');
  const drafts = products.filter((product) => product.shopifyStatus === 'draft').length;
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('papBulk.dialogTitle', { count: products.length })}</AlertDialogTitle>
          <AlertDialogDescription>
            {drafts > 0 ? t('papBulk.dialogBodyDrafts', { drafts }) : t('papBulk.dialogBodyNoDrafts')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <ul className="max-h-52 divide-y overflow-y-auto rounded-md border">
          {products.map((product) => (
            <li key={product.id} className="flex items-center justify-between gap-3 px-3 py-1.5 text-xs">
              <span className="truncate">{product.title}</span>
              {product.shopifyStatus === 'draft' && <span className="shrink-0 text-[10px] font-semibold uppercase text-amber-700">{t('papView.draftChip')}</span>}
            </li>
          ))}
        </ul>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('papActions.cancel')}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="gap-1.5 bg-threadheads-purple text-white hover:bg-threadheads-purple/90">
            <PackagePlus className="h-4 w-4" aria-hidden="true" />
            {t('papBulk.confirm', { count: products.length })}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
